export const defaultSiteChromeSettings = {
  topbar_phone: "+91 9732022901",
  topbar_email: "help@nidcs.org",
  topbar_notice: "An ISO 9001:2015 Certified & MSME Certified Organization",
  topbar_button_text: "Online Queries",
  topbar_button_link: "/contact",
  footer_eyebrow: "NIDCS",
  footer_heading: "National Institute of Digital Careers and Skills",
  footer_description:
    "Skill development, admissions, centre support, verification, and academic services are presented in a cleaner modern front experience with the same trusted workflow.",
  footer_address: "Bankura, West Bengal",
  footer_phone: "Mob / WhatsApp: +91 9732022901",
  footer_email: "help@nidcs.org",
  facebook_url: "https://facebook.com",
  whatsapp_url: "https://wa.me/919732022901",
  instagram_url: "",
  linkedin_url: "",
  twitter_url: "",
  footer_copyright: "National Institute of Digital Careers and Skills | All Rights Reserved",
};

export function normalizeSiteChromeSettings(value) {
  return {
    ...defaultSiteChromeSettings,
    ...(value || {}),
  };
}
